export type setQueryFunctionType = (field: string, value: any) => void;
export const setQueryFunction =
  (query: any, setter: Function): setQueryFunctionType =>
  (field: string, value: string) => {
    console.log(field, value);
    setter({ ...query, [field]: value });
  };
